
import FollowUserAdd from './pb/FollowUserAdd.pb';
import FollowUserType from './pb/FollowUserType.pb';
import getService from './utils/getService';

const serviceService = getService('service');
const followService = getService('follow');


export const GetType = (uid, userToken) => {
    let param2 = {
        vuid: uid
    };
    const post = followService('/follow/user/type', FollowUserType.Follow.UserType);

    return post(param2, {userToken}).then(res => {
        return res || {};
    })
}

export const AddUser = (uid, userToken) => {
    let param2 = {
        fuid: uid,
        addFriend: false
    };

    const post = followService('/follow/user/add', FollowUserAdd.Follow.UserAdd);

    return post(param2, {userToken}).then(res => {
        return res || {};
    })
}


// WEBPACK FOOTER //
// ./js/_service/follwUser.js